import React  from 'react';
import { DbnpBasicInfoComponent } from './dbnp-basic-info.component';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import DbnpRegistriesComponent from './dbnp-registries.component';
import DBNPOrgRegistries from '../containers/dbnp-org-registries';


export const DbnpComponent = ({handlePopulateOrgRegistry,id,countries,subDomains,domains,opsnumber,handleFormChange,selectedDbnpRegistry, handleInnerFormChange,selectedDbnp,organizationUnits,back,handleFormSubmit}: any) => {
  console.log(selectedDbnpRegistry,'selectedDbnpRegistry')
  const tabItems=[
    {
        id:1,
        title:'Basic Info',
        component:<DbnpBasicInfoComponent
        selectedDbnp={selectedDbnp}
        handleInnerFormChange={handleInnerFormChange}
        organizationUnits={organizationUnits}
        handleFormChange={handleFormChange}
        selectedDbnpRegistry={selectedDbnpRegistry}
        opsnumber={opsnumber}
       domains={domains}
       subDomains={subDomains}
       countries={countries}
       id={id}
      />,
    isVisible:true,
    },
    {
      id:2,
      title:'DBNP registry Details',
      component: <DbnpRegistriesComponent
      handleBacicInnerFormChange={handleInnerFormChange}
      handleInnerFormChange ={handleFormChange}
      selectedDbnpRegistry={selectedDbnpRegistry}
      opsnumber={opsnumber}
     domains={domains}
     subDomains={subDomains}
     countries={countries}
     id={id}
/>,
  isVisible:selectedDbnp?.IsEnableDbnpRegistry? true: false,
  },
  {
    id: 3,
    title: 'Org Registries',
    component: <DBNPOrgRegistries
    selectedDbnpRegistry={selectedDbnpRegistry}
    />, 
    isVisible:selectedDbnpRegistry?.DBNPId? true: false,
  },
  ]
    
  return (
   <>
       
      
       <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end mr-12 '>
        <button
              onClick={back}
              type='button'
              className="m-2 ml-12 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
             <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}
              type="submit"
          >
            Save
          </button>
        </div>
        </div>
        </>
  )
}
export default DbnpComponent;
